<template>
  <v-container>
    <div class="base-page">
      <logo-with-title :title="$t('register')" />
      <v-row justify="center">
        <v-col>
          <v-alert v-if="errors.token" dense outlined type="error">
            <p>
              {{ errors.token }}
            </p>
          </v-alert>
        </v-col>
      </v-row>
      <register-form
        :loading="loading"
        :errors="errors"
        @submit="onSubmit"
        @login="gotoLogin"
      />
    </div>
  </v-container>
</template>

<script>
import LaravelErrors from "../../helpers/LaravelErrors";
import rules from "../../helpers/rules";
import RegisterForm from "./RegisterForm";
import LogoWithTitle from "@/components/LogoWithTitle";
export default {
  name: "PassportRegister",
  components: { LogoWithTitle, RegisterForm },
  props: {},
  data: () => ({
    disabled: false,
    form: {},
    rules,
    loading: false,
  }),
  computed: {
    errorBag() {
      const errorsBag = window.errorsBag;
      if (Array.isArray(errorsBag)) return {};
      return errorsBag;
    },
    errors() {
      return LaravelErrors.getFirstErrorOnly(window.errorsBag);
    },
  },

  methods: {
    gotoLogin() {
      window.errorsBag = [];
      window.olds = [];
      this.$router.push({ path: "/login" });
    },
    async onSubmit(params) {
      const e = params.event;
      const isProduction = process.env.NODE_ENV === "production";

      console.log("onSubmit valid");

      this.loading = true;

      if (!isProduction || !window.grecaptcha) {
        this.$nextTick(function () {
          e.target.submit();
        });
        return;
      }

      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute("6LfjJxIpAAAAAMF-A4Wy-3N5inutHYoivHiLFpR2", {
            action: "submit",
          })
          .then(async (token) => {
            // Add your logic to submit to your backend server here.
            try {
              const hiddenInput = document.createElement("input");
              hiddenInput.type = "hidden";
              hiddenInput.name = "token";
              hiddenInput.value = token;

              // Append it to the form
              e.target.appendChild(hiddenInput);
              this.$nextTick(function () {
                e.target.submit();
              });
            } catch (error) {}
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../sass/generic";

.page {
  width: 90%;
  margin: auto;
  background-color: $background;

  @include responsive($mobile) {
    max-width: $mobile !important;
    max-height: $mobile-height;
  }

  .project-name {
    &--col {
      padding: 0;

      div {
        height: 40px;
        width: 220px;
        background: #4595cc 0 0 no-repeat padding-box;
        border-radius: 0 0 20px 20px;
        opacity: 1;
      }
    }
  }
}
</style>
